var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrenth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2574813_dumbbells_exercise_fitness_gym_workout_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13853",
    d: "M7.5 9.5H10.5V22.5H7.5V9.5Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13855",
    d: "M2.5 14.5H4.5V17.5H2.5V14.5Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13857",
    d: "M4.5 12H7.5V20H4.5V12Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13859",
    d: "M10.5 14.5H21.5V17.5H10.5V14.5Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13861",
    d: "M24.5 9.5H21.5V22.5H24.5V9.5Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13863",
    d: "M29.5 14.5H27.5V17.5H29.5V14.5Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13865",
    d: "M27.5 12H24.5V20H27.5V12Z",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrenth);
export default __webpack_public_path__ + "static/media/strenth.ba8c18fb397d6c47e875b0dacbb3c997.svg";
export { ForwardRef as ReactComponent };